<vdr-card class="mb-4" *ngIf="!isCreatePage">
    <div class="flex items-center justify-between mb-4">
        <h4 class="text-xl font-semibold">Send Push Notification</h4>
    </div>
    <form [formGroup]="detailForm">
        <div class="form-grid">
            <vdr-form-field label="Title" for="title">
                <input id="title" [readonly]="!'UpdatePromotion'" type="text" formControlName="title" />
            </vdr-form-field>
            <vdr-rich-text-editor
                class="form-grid-span"
                formControlName="body"
                [readonly]="!'UpdatePromotion'"
                label="Body"
            ></vdr-rich-text-editor>
            <vdr-form-field label="Include Banner" for="includeBanner">
                <input id="includeBanner" type="checkbox" clrCheckbox formControlName="includeBanner" />
            </vdr-form-field>
        </div>
    </form>

    <div class="mt-4 flex justify-end">
        <button type="button" class="btn btn-primary" (click)="sendNotification()">
            Send Push Notification
        </button>
    </div>
</vdr-card>
